import { useIsAdmin, useIsSuperAdmin } from 'providers/UserProvider';
import { useIsCustomer } from 'providers/CustomerProvider';
import { Redirect, Route } from 'react-router-dom';
import { getUserInStorage } from './Storage';

export default function AdminRoute({ component: Component, ...rest }) {
  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin();
  const isCustomer = useIsCustomer();
  console.log("isAdmin",isAdmin)
  console.log("isSuperAdmin",isSuperAdmin)
  return (
    <Route
      {...rest}
      render={(props) =>
        isSuperAdmin || getUserInStorage()?.isSuperAdmin? (
          <Component {...props} />
        ) :isAdmin || getUserInStorage()?.isAdmin?
        <Redirect to="/invoices" />
        :isCustomer?
          <Redirect to="/customer/events" />
        : (
          <Redirect to="/invoices" />
        )
      }
    />
  );
}
